import {useProperties} from '../../SidePanel/RightPanel/Properties.mjs'

import {
    PropertiesController,
    usePropertiesController,
} from '../../SidePanel/RightPanel/PropertiesController.jsx'

import SelectUv from '../UV/SelectUv.jsx'

export default function PropertiesControllerUv({
    className,
    style,
    codeProp = 'uvCode',
    disabled,
    hidden,
    idProp = 'uvId',
    label,
    labelSuffix,
    nameProp = 'uvName',
    readOnly,
    required,
    ...props
}) {
    const [values, update] = useProperties()

    const {
        uiCode,
        [codeProp]: uvCode,
        [idProp]: uvId,
        [nameProp]: uvName,
    } = values

    const handleChange = uv => {
        const {
            uvCode = '',
            uvId = '',
            uvName = '',
        } = uv ?? {}

        update({
            [codeProp]: uvCode,
            [idProp]: uvId,
            [nameProp]: uvName,
        })
    }

    const p = usePropertiesController({
        disabled,
        hidden,
        label,
        prop: codeProp,
        readOnly,
        required,
    })

    return (
        <PropertiesController
            className={className}
            style={style}
            hidden={p.hidden}
            label={p.label}
            labelSuffix={labelSuffix}
            required={p.required}
        >
            <SelectUv
                disabled={p.disabled}
                readOnly={p.readOnly}
                uiCode={uiCode}
                value={{uvCode, uvId, uvName}}
                onChange={handleChange}
                {...props}
            />
        </PropertiesController>
    )
}
